// 本模块为本地视图相关逻辑及状态,主要用来做页面传参
import Vue from 'vue'

const state = {
	/**
	 * webview地址
	 */
    webSite: '',
    imageSrc: '',
    jumpUrl:'',
}

const getters = {
    webSite(state) {
        return state.webSite
    },
    imageSrc(state) {
        return state.imageSrc
    },
    jumpUrl(state) {
        return state.jumpUrl
    },
}

const mutations = {
    setWebSite(state, detail) {
        state.webSite = detail
    },
    setImageSrc(state, data) {
        state.imageSrc = data
    },
    setJumpUrl(state, data) {
        state.jumpUrl = data
    },
}

const actions = {
    saveJumpUrl({ state, dispatch, commit },urlInfo){
        commit('setJumpUrl', urlInfo)
    },
    // 跳转方式区分
    jumpChoice({ state, dispatch, commit }, urlInfo) {
        let reg = /^(http|https|img|page|tab):\/\/(.+)$/;
        let match
        let schema
        let href
        if(urlInfo){
            match = reg.exec(urlInfo);
            schema = match[1];
            href = match[2];
        }
        if (schema == 'http' || schema == 'https') {
            dispatch('goWebView', "https://" + href)
        } else if (schema == "img") {
            dispatch('goImage', "https://" + href)
        } else if (schema == "page") {
            dispatch('goNavigateTo', "/" + href)
        } else if (schema == "tab") {
            dispatch('goSwitchTab', "/" + href)
        } 
    },
    // 跳转到webview
    goWebView({ state, commit }, detail) {
        commit('setWebSite', detail)
        uni.navigateTo({
            url: '/pages/webView/webView',
            success() {}
        })
    },
    // 跳转到查看图片页面
    goImage({ state, commit }, detail) {
        commit('setImageSrc', detail)
        uni.navigateTo({
            url: '/pages/Image/Image',
            success() {}
        })
    },
    // 跳转内置链接
    goNavigateTo({ state, commit }, url) {
        uni.navigateTo({
            url: url,
        })
    },
    // 跳转tabBar
    goSwitchTab({ state, commit }, url) {
        uni.switchTab({
            url: url,
        })
    },
}
export default {
    state,
    getters,
    actions,
    mutations
}


// WEBPACK FOOTER //
// ./src/store/modules/locationMethod.js